import React, { useState } from 'react';
import { AlertCircle } from 'react-feather';

const TextArea = ({ label, value, name, error, placeholder, customclass }) => {
  const [textValue, setTextValue] = useState(value);
  const handleChange = (event) => {
    setTextValue(event.target.value);
  };
  return (
    <div className='form-group'>
      {label && (
        <label htmlFor={name} style={{ color: '#0678e6', fontWeight: 600 }}>
          {label}
        </label>
      )}
      <div className='input-container'>
        <textarea
          id={name}
          name={name}
          value={textValue}
          onChange={handleChange}
          placeholder={placeholder}
          className={customclass}
        ></textarea>
      </div>
      {error && (
        <div className='alert alert-danger'>
          <AlertCircle size={14} /> {`  ${error}`}
        </div>
      )}
    </div>
  );
};

export default TextArea;
